import React from 'react'
import ProductsMenFootwear from './ProductsMenFootwear'


export default function MenFootwear() {
  return (
    <div>
        <ProductsMenFootwear/>
    </div>
  )
}
